import React, { PropsWithChildren } from 'react';

import Flex from 'components/widgets/ReportsHome/genericLayouts/genericFlex';

const Left = ({ children, ...rest }: PropsWithChildren<{ className?: string }>) => {
    return (
        <Flex gap={8} align={'center'} {...rest}>
            {children}
        </Flex>
    );
};

export default Left;
